import { render, staticRenderFns } from "./element.vue?vue&type=template&id=5ff18adc&scoped=true&"
import script from "./element.vue?vue&type=script&lang=js&"
export * from "./element.vue?vue&type=script&lang=js&"
import style0 from "./element.vue?vue&type=style&index=0&id=5ff18adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff18adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff18adc')) {
      api.createRecord('5ff18adc', component.options)
    } else {
      api.reload('5ff18adc', component.options)
    }
    module.hot.accept("./element.vue?vue&type=template&id=5ff18adc&scoped=true&", function () {
      api.rerender('5ff18adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction_album_weChat/element.vue"
export default component.exports